export class UpdateAudienceRequest {
  profileId: number;
  audienceName: string;
}
